import {useAccessToken} from "../../services/auth"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {
	TransactionMonitoringSettings,
	getTransactionMonitoringSettings,
	updateTransactionMonitoringSettings,
} from "../../resources/transactionMonitoringSettings"
import {useParams} from "react-router"
import Loading from "../../components/Loading/Loading"
import React, {useEffect, useState} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import Back from "../../components/Back/Back"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faEdit, faWindowClose} from "@fortawesome/free-solid-svg-icons"
import {Attributes} from "./Attributes"
import {useToasts} from "react-toast-notifications"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {AsyncResultIdleRequestState} from "../../types/asyncResultIdle"
import {EditMode, ErrorDocument} from "../../resources/common"

type Props = {
	settings: TransactionMonitoringSettings
	refresh: () => void
}

function Page({settings, refresh}: Props) {
	const accessToken = useAccessToken()
	const {addToast} = useToasts()
	const [isEditing, setIsEditing] = useState(false)
	const [state, update] = useAsyncResultIdle(updateTransactionMonitoringSettings)
	const [name, setName] = useState(settings.attributes.name)
	const [fields] = useState<Map<string, number>>(new Map(Object.entries(settings.attributes.fields)))
	// DS
	const [achLoadsDaily, setAchLoadsDaily] = useState<string>(getOrElse(fields, "achLoadsDaily", ""))
	const [achLoadsMonthly, setAchLoadsMonthly] = useState<string>(getOrElse(fields, "achLoadsMonthly", ""))
	const [cardLoadsDaily, setCardLoadsDaily] = useState<string>(getOrElse(fields, "cardLoadsDaily", ""))
	const [cardLoadsMonthly, setCardLoadsMonthly] = useState<string>(getOrElse(fields, "cardLoadsMonthly", ""))
	const [cashLoadsMonthly, setCashLoadsMonthly] = useState<string>(getOrElse(fields, "cashLoadsMonthly", ""))
	const [totalCashMonthly, setTotalCashMonthly] = useState<string>(getOrElse(fields, "totalCashMonthly", ""))
	const [cashLoadsPerTransaction, setCashLoadsPerTransaction] = useState<string>(
		getOrElse(fields, "cashLoadsPerTransaction", "")
	)
	const [cashLoadsDaily, setCashLoadsDaily] = useState<string>(getOrElse(fields, "cashLoadsDaily", ""))
	const [checkLoadsDaily, setCheckLoadsDaily] = useState<string>(getOrElse(fields, "checkLoadsDaily", ""))
	const [checkLoadsMonthly, setCheckLoadsMonthly] = useState<string>(getOrElse(fields, "checkLoadsMonthly", ""))
	const [wireTransferLoadsDaily, setWireTransferLoadsDaily] = useState<string>(
		getOrElse(fields, "wireTransferLoadsDaily", "")
	)
	const [wireTransferLoadsMonthly, setWireTransferLoadsMonthly] = useState<string>(
		getOrElse(fields, "wireTransferLoadsMonthly", "")
	)
	const [totalPurchasesDaily, setTotalPurchasesDaily] = useState<string>(getOrElse(fields, "totalPurchasesDaily", ""))
	const [totalPurchasesMonthly, setTotalPurchasesMonthly] = useState<string>(
		getOrElse(fields, "totalPurchasesMonthly", "")
	)
	const [achDebitDaily, setACHDebitDaily] = useState<string>(getOrElse(fields, "achDebitDaily", ""))
	const [achDebitMonthly, setACHDebitMonthly] = useState<string>(getOrElse(fields, "achDebitMonthly", ""))
	const [totalATMTransactionsDaily, setTotalATMTransactionsDaily] = useState<string>(
		getOrElse(fields, "totalATMTransactionsDaily", "")
	)
	const [totalATMTransactionsMonthly, setTotalATMTransactionsMonthly] = useState<string>(
		getOrElse(fields, "totalATMTransactionsMonthly", "")
	)
	const [totalDebitsDaily, setTotalDebitsDaily] = useState<string>(getOrElse(fields, "totalDebitsDaily", ""))
	const [totalDebitsMonthly, setTotalDebitsMonthly] = useState<string>(getOrElse(fields, "totalDebitsMonthly", ""))
	const [totalCreditsDaily, setTotalCreditsDaily] = useState<string>(getOrElse(fields, "totalCreditsDaily", ""))
	const [totalCreditsMonthly, setTotalCreditsMonthly] = useState<string>(getOrElse(fields, "totalCreditsMonthly", ""))
	const [P2PTransfersDebitDaily, setP2PTransfersDebitDaily] = useState<string>(
		getOrElse(fields, "P2PTransfersDebitDaily", "")
	)
	const [P2PTransfersDebitMonthly, setP2PTransfersDebitMonthly] = useState<string>(
		getOrElse(fields, "P2PTransfersDebitMonthly", "")
	)
	const [P2PTransfersCreditDaily, setP2PTransfersCreditDaily] = useState<string>(
		getOrElse(fields, "P2PTransfersCreditDaily", "")
	)
	const [P2PTransfersCreditMonthly, setP2PTransfersCreditMonthly] = useState<string>(
		getOrElse(fields, "P2PTransfersCreditMonthly", "")
	)
	const [totalP2PTransfersMonthly, setTotalP2PTransfersMonthly] = useState<string>(
		getOrElse(fields, "totalP2PTransfersMonthly", "")
	)
	const [networkLoadsMonthly, setNetworkLoadsMonthly] = useState<string>(getOrElse(fields, "networkLoadsMonthly", ""))
	const [manualLoadsMonthly, setManualLoadsMonthly] = useState<string>(getOrElse(fields, "manualLoadsMonthly", ""))
	const [automatedLoadsMonthly, setAutomatedLoadsMonthly] = useState<string>(
		getOrElse(fields, "automatedLoadsMonthly", "")
	)

	const [cashLoadsDailyCount, setCashLoadsDailyCount] = useState<string>(getOrElse(fields, "cashLoadsDailyCount", ""))
	const [cashLoadsWeeklyCount, setCashLoadsWeeklyCount] = useState<string>(
		getOrElse(fields, "cashLoadsWeeklyCount", "")
	)
	const [cashLoadsWeeklyVolume, setCashLoadsWeeklyVolume] = useState<string>(
		getOrElse(fields, "cashLoadsWeeklyVolume", "")
	)
	const [totalATMTransactionsDailyCount, setTotalATMTransactionsDailyCount] = useState<string>(
		getOrElse(fields, "totalATMTransactionsDailyCount", "")
	)
	const [totalATMTransactionsWeeklyVolume, setTotalATMTransactionsWeeklyVolume] = useState<string>(
		getOrElse(fields, "totalATMTransactionsWeeklyVolume", "")
	)
	const [totalATMTransactionsWeeklyCount, setTotalATMTransactionsWeeklyCount] = useState<string>(
		getOrElse(fields, "totalATMTransactionsWeeklyCount", "")
	)
	const [internationalATMTransactionsDailyVolume, setInternationalATMTransactionsDailyVolume] = useState<string>(
		getOrElse(fields, "internationalATMTransactionsDailyVolume", "")
	)
	const [internationalATMTransactionsDailyCount, setInternationalATMTransactionsDailyCount] = useState<string>(
		getOrElse(fields, "internationalATMTransactionsDailyCount", "")
	)
	const [internationalATMTransactionsWeeklyVolume, setInternationalATMTransactionsWeeklyVolume] = useState<string>(
		getOrElse(fields, "internationalATMTransactionsWeeklyVolume", "")
	)
	const [internationalATMTransactionsWeeklyCount, setInternationalATMTransactionsWeeklyCount] = useState<string>(
		getOrElse(fields, "internationalATMTransactionsWeeklyCount", "")
	)
	const [outgoingWireTransferLoadsDailyVolume, setOutgoingWireTransferLoadsDailyVolume] = useState<string>(
		getOrElse(fields, "outgoingWireTransferLoadsDailyVolume", "")
	)
	const [p2pTransfersDebitWeeklyVolume, setP2PTransfersDebitWeeklyVolume] = useState<string>(
		getOrElse(fields, "p2pTransfersDebitWeeklyVolume", "")
	)
	const [p2pTransfersCreditWeeklyVolume, setP2PTransfersCreditWeeklyVolume] = useState<string>(
		getOrElse(fields, "p2pTransfersCreditWeeklyVolume", "")
	)
	const [c2cTransfersDebitWeeklyVolume, setC2CTransfersDebitWeeklyVolume] = useState<string>(
		getOrElse(fields, "c2cTransfersDebitWeeklyVolume", "")
	)
	const [c2cTransfersCreditWeeklyVolume, setC2CTransfersCreditWeeklyVolume] = useState<string>(
		getOrElse(fields, "c2cTransfersCreditWeeklyVolume", "")
	)
	const [outgoingWireTransferLoadsMonthlyVolume, setOutgoingWireTransferLoadsMonthlyVolume] = useState<string>(
		getOrElse(fields, "outgoingWireTransferLoadsMonthlyVolume", "")
	)

	// CA
	const [varPlinAmount, setVarPlinAmount] = useState<number>(fields.get("var_plin_amount") || 250)
	const [varPloutAmount, setVarPloutAmount] = useState<number>(fields.get("var_plout_amount") || 250)
	const [varHfinNumber, setVarHfinNumber] = useState<number>(fields.get("var_hfin_number") || 3)
	const [varHfoutNumber, setVarHfoutNumber] = useState<number>(fields.get("var_hfout_number") || 3)
	const [varPlmhinNumber, setVarPlmhinNumber] = useState<number>(fields.get("var_plmhin_number") || 2)
	const [varPlmhinAmount, setVarPlmhinAmount] = useState<number>(fields.get("var_plmhin_amount") || 500)
	const [varPlmhinFactor, setVarPlmhinFactor] = useState<number>(fields.get("var_plmhin_factor") || 2)
	const [varPlmhoutNumber, setVarPlmhoutNumber] = useState<number>(fields.get("var_plmhout_number") || 2)
	const [varPlmhoutAmount, setVarPlmhoutAmount] = useState<number>(fields.get("var_plmhout_amount") || 500)
	const [varPlmhoutFactor, setVarPlmhoutFactor] = useState<number>(fields.get("var_plmhout_factor") || 2)
	const [varHfhainNumber, setVarHfhainNumber] = useState<number>(fields.get("var_hfhain_number") || 1)
	const [varHfhainFactor, setVarHfhainFactor] = useState<number>(fields.get("var_hfhain_factor") || 2)
	const [varHfhaoutNumber, setVarHfhaoutNumber] = useState<number>(fields.get("var_hfhaout_number") || 1)
	const [varHfhaoutFactor, setVarHfhaoutFactor] = useState<number>(fields.get("var_hfhaout_factor") || 2)
	const [varStrinNumber, setVarStrinNumber] = useState<number>(fields.get("var_strin_number") || 1)
	const [varStroutNumber, setVarStroutNumber] = useState<number>(fields.get("var_strout_number") || 1)
	const [varPgainAmount, setVarPgainAmount] = useState<number>(fields.get("var_pgain_amount") || 250)
	const [varPgainPercent, setVarPgainPercent] = useState<number>(fields.get("var_pgain_percent") || 50)
	const [varPgaoutAmount, setVarPgaoutAmount] = useState<number>(fields.get("var_pgaout_amount") || 250)
	const [varPgaoutPercent, setVarPgaoutPercent] = useState<number>(fields.get("var_pgaout_percent") || 50)
	const [varHsumcIAmount, setVarHsumcIAmount] = useState<number>(fields.get("var_hsumc_i_amount") || 2000)
	const [varHsumcOAmount, setVarHsumcOAmount] = useState<number>(fields.get("var_hsumc_o_amount") || 5000)
	const [varHvalcOAmount, setVarHvalcOAmount] = useState<number>(fields.get("var_hvalc_o_amount") || 2500)
	const [varHvalcIAmount, setVarHvalcIAmount] = useState<number>(fields.get("var_hvalc_i_amount") || 1000)
	const [varPbalBalance, setVarPbalBalance] = useState<number>(fields.get("var_pbal_balance") || 3000)
	const [varPbalPercentage, setVarPbalPercentage] = useState<number>(fields.get("var_pbal_percentage") || 90)
	const [varPHsumiAmount, setVarPHsumiAmount] = useState<number>(fields.get("var_p_hsumi_amount") || 10000)
	const [varPHsumoAmount, setVarPHsumoAmount] = useState<number>(fields.get("var_p_hsumo_amount") || 10000)
	const [varOutinAmount, setVarOutinAmount] = useState<number>(fields.get("var_outin_amount") || 5000)
	const [varOutinPercentageLow, setVarOutinPercentageLow] = useState<number>(
		fields.get("var_outin_percentage_low") || 90
	)
	const [varOutinPercentageHigh, setVarOutinPercentageHigh] = useState<number>(
		fields.get("var_outin_percentage_high") || 150
	)
	const [varInoutAmount, setVarInoutAmount] = useState<number>(fields.get("var_inout_amount") || 5000)
	const [varInoutPercentageLow, setVarInoutPercentageLow] = useState<number>(
		fields.get("var_inout_percentage_low") || 90
	)
	const [varInoutPercentageHigh, setVarInoutPercentageHigh] = useState<number>(
		fields.get("var_inout_percentage_high") || 150
	)
	const [varHrcouAmount, setVarHrcouAmount] = useState<number>(fields.get("var_hrcou_amount") || 5000)
	const [varNumcrdrfNumber, setVarNumcrdrfNumber] = useState<number>(fields.get("var_numcrdrf_number") || 5)
	const [varCrefsumAmount, setVarCrefsumAmount] = useState<number>(fields.get("var_crefsum_amount") || 100)
	const [varCrefsumNumber, setVarCrefsumNumber] = useState<number>(fields.get("var_crefsum_number") || 1)
	const [varCrefsumFactor, setVarCrefsumFactor] = useState<number>(fields.get("var_crefsum_factor") || 1.5)
	const [varHrmrchntAmount, setVarHrmrchntAmount] = useState<number>(fields.get("var_hrmrchnt_amount") || 500)
	const [varHasumiAmount, setVarHasumiAmount] = useState<number>(fields.get("var_hasumi_amount") || 2000)
	const [varHasumiFactor, setVarHasumiFactor] = useState<number>(fields.get("var_hasumi_factor") || 3)
	const [varHasumoAmount, setVarHasumoAmount] = useState<number>(fields.get("var_hasumo_amount") || 2000)
	const [varHasumoFactor, setVarHasumoFactor] = useState<number>(fields.get("var_hasumo_factor") || 3)

	useEffect(() => {
		if (state.isOk()) {
			addToast("Transaction Monitoring Settings Updated Successfully", {appearance: "success"})
			setIsEditing(false)
			refresh()
		}
	}, [state])

	const submit = () => {
		const newFields = {
			// ds
			...(achLoadsDaily !== "" ? {achLoadsDaily: achLoadsDaily} : {}),
			...(achLoadsMonthly !== "" ? {achLoadsMonthly: achLoadsMonthly} : {}),
			...(cardLoadsDaily !== "" ? {cardLoadsDaily: cardLoadsDaily} : {}),
			...(cardLoadsMonthly !== "" ? {cardLoadsMonthly: cardLoadsMonthly} : {}),
			...(cashLoadsPerTransaction !== "" ? {cashLoadsPerTransaction: cashLoadsPerTransaction} : {}),
			...(cashLoadsDaily !== "" ? {cashLoadsDaily: cashLoadsDaily} : {}),
			...(cashLoadsMonthly !== "" ? {cashLoadsMonthly: cashLoadsMonthly} : {}),
			...(totalCashMonthly !== "" ? {totalCashMonthly: totalCashMonthly} : {}),
			...(checkLoadsDaily !== "" ? {checkLoadsDaily: checkLoadsDaily} : {}),
			...(checkLoadsMonthly !== "" ? {checkLoadsMonthly: checkLoadsMonthly} : {}),
			...(wireTransferLoadsDaily !== "" ? {wireTransferLoadsDaily: wireTransferLoadsDaily} : {}),
			...(wireTransferLoadsMonthly !== "" ? {wireTransferLoadsMonthly: wireTransferLoadsMonthly} : {}),
			...(totalPurchasesDaily !== "" ? {totalPurchasesDaily: totalPurchasesDaily} : {}),
			...(totalPurchasesMonthly !== "" ? {totalPurchasesMonthly: totalPurchasesMonthly} : {}),
			...(achDebitDaily !== "" ? {achDebitDaily: achDebitDaily} : {}),
			...(achDebitMonthly !== "" ? {achDebitMonthly: achDebitMonthly} : {}),
			...(totalATMTransactionsDaily !== "" ? {totalATMTransactionsDaily: totalATMTransactionsDaily} : {}),
			...(totalATMTransactionsMonthly !== "" ? {totalATMTransactionsMonthly: totalATMTransactionsMonthly} : {}),
			...(totalDebitsDaily !== "" ? {totalDebitsDaily: totalDebitsDaily} : {}),
			...(totalDebitsMonthly !== "" ? {totalDebitsMonthly: totalDebitsMonthly} : {}),
			...(totalCreditsDaily !== "" ? {totalCreditsDaily: totalCreditsDaily} : {}),
			...(totalCreditsMonthly !== "" ? {totalCreditsMonthly: totalCreditsMonthly} : {}),
			...(P2PTransfersDebitDaily !== "" ? {P2PTransfersDebitDaily: P2PTransfersDebitDaily} : {}),
			...(P2PTransfersDebitMonthly !== "" ? {P2PTransfersDebitMonthly: P2PTransfersDebitMonthly} : {}),
			...(P2PTransfersCreditDaily !== "" ? {P2PTransfersCreditDaily: P2PTransfersCreditDaily} : {}),
			...(P2PTransfersCreditMonthly !== "" ? {P2PTransfersCreditMonthly: P2PTransfersCreditMonthly} : {}),
			...(totalP2PTransfersMonthly !== "" ? {totalP2PTransfersMonthly: totalP2PTransfersMonthly} : {}),
			...(networkLoadsMonthly !== "" ? {networkLoadsMonthly: networkLoadsMonthly} : {}),
			...(manualLoadsMonthly !== "" ? {manualLoadsMonthly: manualLoadsMonthly} : {}),
			...(automatedLoadsMonthly !== "" ? {automatedLoadsMonthly: automatedLoadsMonthly} : {}),
			...(cashLoadsDailyCount !== "" ? {cashLoadsDailyCount: cashLoadsDailyCount} : {}),
			...(cashLoadsWeeklyCount !== "" ? {cashLoadsWeeklyCount: cashLoadsWeeklyCount} : {}),
			...(cashLoadsWeeklyVolume !== "" ? {cashLoadsWeeklyVolume: cashLoadsWeeklyVolume} : {}),
			...(totalATMTransactionsDailyCount !== ""
				? {totalATMTransactionsDailyCount: totalATMTransactionsDailyCount}
				: {}),
			...(totalATMTransactionsWeeklyVolume !== ""
				? {totalATMTransactionsWeeklyVolume: totalATMTransactionsWeeklyVolume}
				: {}),
			...(totalATMTransactionsWeeklyCount !== ""
				? {totalATMTransactionsWeeklyCount: totalATMTransactionsWeeklyCount}
				: {}),
			...(internationalATMTransactionsDailyVolume !== ""
				? {internationalATMTransactionsDailyVolume: internationalATMTransactionsDailyVolume}
				: {}),
			...(internationalATMTransactionsDailyCount !== ""
				? {internationalATMTransactionsDailyCount: internationalATMTransactionsDailyCount}
				: {}),
			...(internationalATMTransactionsWeeklyVolume !== ""
				? {internationalATMTransactionsWeeklyVolume: internationalATMTransactionsWeeklyVolume}
				: {}),
			...(internationalATMTransactionsWeeklyCount !== ""
				? {internationalATMTransactionsWeeklyCount: internationalATMTransactionsWeeklyCount}
				: {}),
			...(outgoingWireTransferLoadsDailyVolume !== ""
				? {outgoingWireTransferLoadsDailyVolume: outgoingWireTransferLoadsDailyVolume}
				: {}),
			...(p2pTransfersDebitWeeklyVolume !== "" ? {p2pTransfersDebitWeeklyVolume: p2pTransfersDebitWeeklyVolume} : {}),
			...(p2pTransfersCreditWeeklyVolume !== ""
				? {p2pTransfersCreditWeeklyVolume: p2pTransfersCreditWeeklyVolume}
				: {}),
			...(c2cTransfersDebitWeeklyVolume !== "" ? {c2cTransfersDebitWeeklyVolume: c2cTransfersDebitWeeklyVolume} : {}),
			...(c2cTransfersCreditWeeklyVolume !== ""
				? {c2cTransfersCreditWeeklyVolume: c2cTransfersCreditWeeklyVolume}
				: {}),
			...(outgoingWireTransferLoadsMonthlyVolume !== ""
				? {outgoingWireTransferLoadsMonthlyVolume: outgoingWireTransferLoadsMonthlyVolume}
				: {}),

			//ca
			var_plin_amount: varPlinAmount,
			var_plout_amount: varPloutAmount,
			var_hfin_number: varHfinNumber,
			var_hfout_number: varHfoutNumber,
			var_plmhin_number: varPlmhinNumber,
			var_plmhin_amount: varPlmhinAmount,
			var_plmhin_factor: varPlmhinFactor,
			var_plmhout_number: varPlmhoutNumber,
			var_plmhout_amount: varPlmhoutAmount,
			var_plmhout_factor: varPlmhoutFactor,
			var_hfhain_number: varHfhainNumber,
			var_hfhain_factor: varHfhainFactor,
			var_hfhaout_number: varHfhaoutNumber,
			var_hfhaout_factor: varHfhaoutFactor,
			var_strin_number: varStrinNumber,
			var_strout_number: varStroutNumber,
			var_pgain_amount: varPgainAmount,
			var_pgain_percent: varPgainPercent,
			var_pgaout_amount: varPgaoutAmount,
			var_pgaout_percent: varPgaoutPercent,
			var_hsumc_i_amount: varHsumcIAmount,
			var_hsumc_o_amount: varHsumcOAmount,
			var_hvalc_o_amount: varHvalcOAmount,
			var_hvalc_i_amount: varHvalcIAmount,
			var_pbal_balance: varPbalBalance,
			var_pbal_percentage: varPbalPercentage,
			var_p_hsumi_amount: varPHsumiAmount,
			var_p_hsumo_amount: varPHsumoAmount,
			var_outin_amount: varOutinAmount,
			var_outin_percentage_low: varOutinPercentageLow,
			var_outin_percentage_high: varOutinPercentageHigh,
			var_inout_amount: varInoutAmount,
			var_inout_percentage_low: varInoutPercentageLow,
			var_inout_percentage_high: varInoutPercentageHigh,
			var_hrcou_amount: varHrcouAmount,
			var_numcrdrf_number: varNumcrdrfNumber,
			var_crefsum_amount: varCrefsumAmount,
			var_crefsum_number: varCrefsumNumber,
			var_crefsum_factor: varCrefsumFactor,
			var_hrmrchnt_amount: varHrmrchntAmount,
			var_hasumi_amount: varHasumiAmount,
			var_hasumi_factor: varHasumiFactor,
			var_hasumo_amount: varHasumoAmount,
			var_hasumo_factor: varHasumoFactor,
		}

		update(accessToken, settings.id, name, newFields)
	}

	return (
		<>
			<TitleBar>
				<ul>
					<li>Transaction Monitoring Settings</li>
					<li>{settings.attributes.name}</li>
				</ul>
			</TitleBar>
			<MainSection>
				<div className="columns">
					<div className="column">
						<div className="buttons">
							<Back />
							<button className="button is-light" onClick={() => (!isEditing ? setIsEditing(true) : refresh())}>
								<span>{isEditing ? "Cancel" : "Edit"}</span>
								<span className="icon">
									<FontAwesomeIcon icon={isEditing ? faWindowClose : faEdit} />
								</span>
							</button>
						</div>
					</div>
				</div>
				<form
					onSubmit={(e) => {
						e.preventDefault()
						submit()
					}}
				>
					<fieldset disabled={!isEditing}>
						<Attributes
							editMode={isEditing ? EditMode.EDIT : EditMode.VIEW}
							name={name}
							setName={setName}
							//ds
							achLoadsDaily={achLoadsDaily}
							achLoadsMonthly={achLoadsMonthly}
							cardLoadsDaily={cardLoadsDaily}
							cardLoadsMonthly={cardLoadsMonthly}
							cashLoadsPerTransaction={cashLoadsPerTransaction}
							cashLoadsDaily={cashLoadsDaily}
							cashLoadsMonthly={cashLoadsMonthly}
							totalCashMonthly={totalCashMonthly}
							checkLoadsDaily={checkLoadsDaily}
							checkLoadsMonthly={checkLoadsMonthly}
							wireTransferLoadsDaily={wireTransferLoadsDaily}
							wireTransferLoadsMonthly={wireTransferLoadsMonthly}
							totalPurchasesDaily={totalPurchasesDaily}
							totalPurchasesMonthly={totalPurchasesMonthly}
							achDebitDaily={achDebitDaily}
							achDebitMonthly={achDebitMonthly}
							totalATMTransactionsDaily={totalATMTransactionsDaily}
							totalATMTransactionsMonthly={totalATMTransactionsMonthly}
							totalDebitsDaily={totalDebitsDaily}
							totalDebitsMonthly={totalDebitsMonthly}
							totalCreditsDaily={totalCreditsDaily}
							totalCreditsMonthly={totalCreditsMonthly}
							P2PTransfersDebitDaily={P2PTransfersDebitDaily}
							P2PTransfersDebitMonthly={P2PTransfersDebitMonthly}
							P2PTransfersCreditDaily={P2PTransfersCreditDaily}
							P2PTransfersCreditMonthly={P2PTransfersCreditMonthly}
							totalP2PTransfersMonthly={totalP2PTransfersMonthly}
							networkLoadsMonthly={networkLoadsMonthly}
							manualLoadsMonthly={manualLoadsMonthly}
							automatedLoadsMonthly={automatedLoadsMonthly}
							cashLoadsDailyCount={cashLoadsDailyCount}
							cashLoadsWeeklyCount={cashLoadsWeeklyCount}
							cashLoadsWeeklyVolume={cashLoadsWeeklyVolume}
							totalATMTransactionsDailyCount={totalATMTransactionsDailyCount}
							totalATMTransactionsWeeklyVolume={totalATMTransactionsWeeklyVolume}
							totalATMTransactionsWeeklyCount={totalATMTransactionsWeeklyCount}
							internationalATMTransactionsDailyVolume={internationalATMTransactionsDailyVolume}
							internationalATMTransactionsDailyCount={internationalATMTransactionsDailyCount}
							internationalATMTransactionsWeeklyVolume={internationalATMTransactionsWeeklyVolume}
							internationalATMTransactionsWeeklyCount={internationalATMTransactionsWeeklyCount}
							outgoingWireTransferLoadsDailyVolume={outgoingWireTransferLoadsDailyVolume}
							p2pTransfersDebitWeeklyVolume={p2pTransfersDebitWeeklyVolume}
							p2pTransfersCreditWeeklyVolume={p2pTransfersCreditWeeklyVolume}
							c2cTransfersDebitWeeklyVolume={c2cTransfersDebitWeeklyVolume}
							c2cTransfersCreditWeeklyVolume={c2cTransfersCreditWeeklyVolume}
							outgoingWireTransferLoadsMonthlyVolume={outgoingWireTransferLoadsMonthlyVolume}
							//ca
							varPlinAmount={varPlinAmount}
							varPloutAmount={varPloutAmount}
							varHfinNumber={varHfinNumber}
							varHfoutNumber={varHfoutNumber}
							varPlmhinNumber={varPlmhinNumber}
							varPlmhinAmount={varPlmhinAmount}
							varPlmhinFactor={varPlmhinFactor}
							varPlmhoutNumber={varPlmhoutNumber}
							varPlmhoutAmount={varPlmhoutAmount}
							varPlmhoutFactor={varPlmhoutFactor}
							varHfhainNumber={varHfhainNumber}
							varHfhainFactor={varHfhainFactor}
							varHfhaoutNumber={varHfhaoutNumber}
							varHfhaoutFactor={varHfhaoutFactor}
							varStrinNumber={varStrinNumber}
							varStroutNumber={varStroutNumber}
							varPgainAmount={varPgainAmount}
							varPgainPercent={varPgainPercent}
							varPgaoutAmount={varPgaoutAmount}
							varPgaoutPercent={varPgaoutPercent}
							varHsumcIAmount={varHsumcIAmount}
							varHsumcOAmount={varHsumcOAmount}
							varHvalcOAmount={varHvalcOAmount}
							varHvalcIAmount={varHvalcIAmount}
							varPbalBalance={varPbalBalance}
							varPbalPercentage={varPbalPercentage}
							varPHsumiAmount={varPHsumiAmount}
							varPHsumoAmount={varPHsumoAmount}
							varOutinAmount={varOutinAmount}
							varOutinPercentageLow={varOutinPercentageLow}
							varOutinPercentageHigh={varOutinPercentageHigh}
							varInoutAmount={varInoutAmount}
							varInoutPercentageLow={varInoutPercentageLow}
							varInoutPercentageHigh={varInoutPercentageHigh}
							varHrcouAmount={varHrcouAmount}
							varNumcrdrfNumber={varNumcrdrfNumber}
							varCrefsumAmount={varCrefsumAmount}
							varCrefsumNumber={varCrefsumNumber}
							varCrefsumFactor={varCrefsumFactor}
							varHrmrchntAmount={varHrmrchntAmount}
							varHasumiAmount={varHasumiAmount}
							varHasumiFactor={varHasumiFactor}
							varHasumoAmount={varHasumoAmount}
							varHasumoFactor={varHasumoFactor}
							//ds
							setAchLoadsDaily={setAchLoadsDaily}
							setAchLoadsMonthly={setAchLoadsMonthly}
							setCardLoadsDaily={setCardLoadsDaily}
							setCardLoadsMonthly={setCardLoadsMonthly}
							setCashLoadsPerTransaction={setCashLoadsPerTransaction}
							setCashLoadsDaily={setCashLoadsDaily}
							setCashLoadsMonthly={setCashLoadsMonthly}
							setTotalCashMonthly={setTotalCashMonthly}
							setCheckLoadsDaily={setCheckLoadsDaily}
							setCheckLoadsMonthly={setCheckLoadsMonthly}
							setWireTransferLoadsDaily={setWireTransferLoadsDaily}
							setWireTransferLoadsMonthly={setWireTransferLoadsMonthly}
							setTotalPurchasesDaily={setTotalPurchasesDaily}
							setTotalPurchasesMonthly={setTotalPurchasesMonthly}
							setAchDebitDaily={setACHDebitDaily}
							setAchDebitMonthly={setACHDebitMonthly}
							setTotalATMTransactionsDaily={setTotalATMTransactionsDaily}
							setTotalATMTransactionsMonthly={setTotalATMTransactionsMonthly}
							setTotalDebitsDaily={setTotalDebitsDaily}
							setTotalDebitsMonthly={setTotalDebitsMonthly}
							setTotalCreditsDaily={setTotalCreditsDaily}
							setTotalCreditsMonthly={setTotalCreditsMonthly}
							setP2PTransfersDebitDaily={setP2PTransfersDebitDaily}
							setP2PTransfersDebitMonthly={setP2PTransfersDebitMonthly}
							setP2PTransfersCreditDaily={setP2PTransfersCreditDaily}
							setP2PTransfersCreditMonthly={setP2PTransfersCreditMonthly}
							setTotalP2PTransfersMonthly={setTotalP2PTransfersMonthly}
							setNetworkLoadsMonthly={setNetworkLoadsMonthly}
							setManualLoadsMonthly={setManualLoadsMonthly}
							setAutomatedLoadsMonthly={setAutomatedLoadsMonthly}
							setCashLoadsDailyCount={setCashLoadsDailyCount}
							setCashLoadsWeeklyCount={setCashLoadsWeeklyCount}
							setCashLoadsWeeklyVolume={setCashLoadsWeeklyVolume}
							setTotalATMTransactionsDailyCount={setTotalATMTransactionsDailyCount}
							setTotalATMTransactionsWeeklyVolume={setTotalATMTransactionsWeeklyVolume}
							setTotalATMTransactionsWeeklyCount={setTotalATMTransactionsWeeklyCount}
							setInternationalATMTransactionsDailyVolume={setInternationalATMTransactionsDailyVolume}
							setInternationalATMTransactionsDailyCount={setInternationalATMTransactionsDailyCount}
							setInternationalATMTransactionsWeeklyVolume={setInternationalATMTransactionsWeeklyVolume}
							setInternationalATMTransactionsWeeklyCount={setInternationalATMTransactionsWeeklyCount}
							setP2PTransfersDebitWeeklyVolume={setP2PTransfersDebitWeeklyVolume}
							setOutgoingWireTransferLoadsDailyVolume={setOutgoingWireTransferLoadsDailyVolume}
							setP2PTransfersCreditWeeklyVolume={setP2PTransfersCreditWeeklyVolume}
							setC2CTransfersDebitWeeklyVolume={setC2CTransfersDebitWeeklyVolume}
							setC2CTransfersCreditWeeklyVolume={setC2CTransfersCreditWeeklyVolume}
							setOutgoingWireTransferLoadsMonthlyVolume={setOutgoingWireTransferLoadsMonthlyVolume}
							//ca
							setVarPlinAmount={setVarPlinAmount}
							setVarPloutAmount={setVarPloutAmount}
							setVarHfinNumber={setVarHfinNumber}
							setVarHfoutNumber={setVarHfoutNumber}
							setVarPlmhinNumber={setVarPlmhinNumber}
							setVarPlmhinAmount={setVarPlmhinAmount}
							setVarPlmhinFactor={setVarPlmhinFactor}
							setVarPlmhoutNumber={setVarPlmhoutNumber}
							setVarPlmhoutAmount={setVarPlmhoutAmount}
							setVarPlmhoutFactor={setVarPlmhoutFactor}
							setVarHfhainNumber={setVarHfhainNumber}
							setVarHfhainFactor={setVarHfhainFactor}
							setVarHfhaoutNumber={setVarHfhaoutNumber}
							setVarHfhaoutFactor={setVarHfhaoutFactor}
							setVarStrinNumber={setVarStrinNumber}
							setVarStroutNumber={setVarStroutNumber}
							setVarPgainAmount={setVarPgainAmount}
							setVarPgainPercent={setVarPgainPercent}
							setVarPgaoutAmount={setVarPgaoutAmount}
							setVarPgaoutPercent={setVarPgaoutPercent}
							setVarHsumcIAmount={setVarHsumcIAmount}
							setVarHsumcOAmount={setVarHsumcOAmount}
							setVarHvalcOAmount={setVarHvalcOAmount}
							setVarHvalcIAmount={setVarHvalcIAmount}
							setVarPbalBalance={setVarPbalBalance}
							setVarPbalPercentage={setVarPbalPercentage}
							setVarPHsumiAmount={setVarPHsumiAmount}
							setVarPHsumoAmount={setVarPHsumoAmount}
							setVarOutinAmount={setVarOutinAmount}
							setVarOutinPercentageLow={setVarOutinPercentageLow}
							setVarOutinPercentageHigh={setVarOutinPercentageHigh}
							setVarInoutAmount={setVarInoutAmount}
							setVarInoutPercentageLow={setVarInoutPercentageLow}
							setVarInoutPercentageHigh={setVarInoutPercentageHigh}
							setVarHrcouAmount={setVarHrcouAmount}
							setVarNumcrdrfNumber={setVarNumcrdrfNumber}
							setVarCrefsumAmount={setVarCrefsumAmount}
							setVarCrefsumNumber={setVarCrefsumNumber}
							setVarCrefsumFactor={setVarCrefsumFactor}
							setVarHrmrchntAmount={setVarHrmrchntAmount}
							setVarHasumiAmount={setVarHasumiAmount}
							setVarHasumiFactor={setVarHasumiFactor}
							setVarHasumoAmount={setVarHasumoAmount}
							setVarHasumoFactor={setVarHasumoFactor}
						/>
						{isEditing ? (
							<div className="columns">
								<div className="column">
									<div className="card">
										<Footer state={state} />
									</div>
								</div>
							</div>
						) : null}
					</fieldset>
				</form>
			</MainSection>
		</>
	)
}

function Footer({state}: {state: AsyncResultIdleRequestState<TransactionMonitoringSettings, ErrorDocument>}) {
	return (
		<div className="card-content">
			{state.match(
				() => (
					<button className="button is-success">Update</button>
				),
				() => (
					<button className="button is-success is-loading">Updating</button>
				),
				(_) => null,
				(err) => (
					<>
						<div className="has-text-danger">{err.errors[0].title}</div>
						<button className="button is-success">Update</button>
					</>
				)
			)}
		</div>
	)
}

export default function TransactionMonitoringSettingsPage() {
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const {settingsId = ""} = useParams<{settingsId: string}>()
	const transactionMonitoringSettingsResult = useAsyncResult(
		() => getTransactionMonitoringSettings(accessToken, settingsId),
		[refreshToken]
	)

	return transactionMonitoringSettingsResult.match(
		() => <Loading />,
		(transactionMonitoringSettingsResult) => (
			<Page settings={transactionMonitoringSettingsResult} refresh={refresh}></Page>
		),
		(_) => null
	)
}

export function getOrElse(map: Map<string, number>, key: string, defaultValue: string) {
	return (map.has(key) ? map.get(key) : defaultValue) as string
}
